module.exports = __webpack_public_path__ + "img/IK.1f3c9963.png";